import { z } from 'zod';

import {
	MobilityDirectionV5x4,
	MobilitySourceV5x4,
	MobilityStatusV5x4,
	MobilityInternalStatusV5x4,
} from '../../../../api/generated/cz.partners.bank.backofficegateway.mobility';
import { UUID_SCHEMA } from '../../../../const/zod/zod';
import { createDateSchemaWithDefinedMinAndMaxBankValues } from '../../../../helpers/zod/createDateSchemaWithDefinedMinAndMaxBankValues';
import { createEnumArraySchema } from '../../../../helpers/zod/createEnumArraySchema';
import { validateDateRange } from '../../../../helpers/zod/validateDateRange';

export type MobilityApplicationFilterErrorMessages = {
	dateFromError: string;
	dateToError: string;
	dateCantBeEarlierThanBankInceptionDateError: string;
	creationDateToBeforeFromError: string;
};

export const getMobilityApplicationFilterSchema = (
	errorMessages?: MobilityApplicationFilterErrorMessages,
) => {
	const mobilityApplicationFilterFormSchema = z
		.object({
			direction: createEnumArraySchema(MobilityDirectionV5x4),
			status: createEnumArraySchema(MobilityStatusV5x4),
			mobilitySource: createEnumArraySchema(MobilitySourceV5x4),
			internalStatus: createEnumArraySchema(MobilityInternalStatusV5x4),
			mobilityDateFrom: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.dateFromError,
			}),
			mobilityDateTo: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.dateToError,
			}),
			creationDateFrom: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.dateFromError,
			}),
			creationDateTo: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.dateToError,
			}),
			updatedDateFrom: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.dateFromError,
			}),
			updatedDateTo: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.dateToError,
			}),
			pidUuid: UUID_SCHEMA.prefault(null),
			mobilityUuid: UUID_SCHEMA.prefault(null),
			hasDocumentsPendingProcessing: z.boolean().prefault(false),
		})
		.superRefine(
			(
				{
					creationDateFrom,
					creationDateTo,
					mobilityDateFrom,
					mobilityDateTo,
					updatedDateFrom,
					updatedDateTo,
				},
				ctx,
			) => {
				validateDateRange(
					creationDateFrom,
					creationDateTo,
					errorMessages?.creationDateToBeforeFromError,
					ctx,
					'creationDateTo',
				);

				validateDateRange(
					mobilityDateFrom,
					mobilityDateTo,
					errorMessages?.creationDateToBeforeFromError,
					ctx,
					'mobilityDateTo',
				);

				validateDateRange(
					updatedDateFrom,
					updatedDateTo,
					errorMessages?.creationDateToBeforeFromError,
					ctx,
					'updatedDateTo',
				);
			},
		);

	return mobilityApplicationFilterFormSchema;
};

export type MobilityApplicationFilterForm = z.infer<
	ReturnType<typeof getMobilityApplicationFilterSchema>
>;
